import { omit as _omit } from "lodash";

export const addMapping = <T extends { [p: string]: string[] } | { [p: number]: string[] }>(
    mapping: T,
    id: string,
    key: string | number,
    singleIdPerKey: boolean = true,
): T => {
    const newMapping = { ...mapping };
    newMapping[key] = singleIdPerKey ? [id] : [...(newMapping[key] || []), id];
    return newMapping;
};

export const removeMapping = <T extends { [p: string]: string[] } | { [p: number]: string[] }>(
    mapping: T,
    id: string,
    key?: string | number,
): T => {
    const newMapping = { ...mapping };
    const _key =
        key ||
        Object.entries(newMapping)
            .filter(([, v]) => v.includes(id))
            ?.map(([k]) => k)?.[0];
    // No corresponding key found for given id... return mapping as is
    if (!_key) return newMapping;
    newMapping[_key] = newMapping[_key].filter((i: string) => i !== id);
    return !newMapping[_key].length
        ? (_omit(newMapping as object, _key) as T) // Remove empty key mapping
        : newMapping;
};
